export const SETTINGS_LOAN_PROVIDERS_LIST = 'loanProviderTypes'
export const SETTINGS_APPROVAL_TIME_LIST = 'approvalTimes'
export const SETTINGS_LTV_LIST = 'ltvs'
export const SETTINGS_PRODUCT_TYPE_LIST = 'productTypes'
export const SETTINGS_PRODUCT_SCHEME_LIST = 'productSchemes'
export const SETTINGS_MOTOR_TYPE_LIST = 'productMotorTypes'
export const SETTINGS_PRODUCT_CATEGORIES_LIST = 'productCategories'
export const SETTINGS_PRODUCT_USAGES_LIST = 'productUsages'


export const BASE_URL = 'https://api.ohhto.com/v1/'
export const IMAGE_BASE_URL = 'https://api.ohhto.com'
export const LOAN_PROVIDER_IMAGE_BASE_URL = 'https://api.ohhto.com'
export const AGENT_IMAGE_BASE_URL = 'https://api.ohhto.com'
export const DEALER_IMAGE_BASE_URL = 'https://api.ohhto.com'
export const LOAN_PRODUCT_IMAGE_BASE_URL = 'https://api.ohhto.com/public/uploads/loanproduct'

// export const BASE_URL = 'http://localhost:8000/v1/'
// export const IMAGE_BASE_URL = 'http://localhost:8000/'
// export const LOAN_PROVIDER_IMAGE_BASE_URL = 'http://localhost:8000/'
// export const AGENT_IMAGE_BASE_URL = 'http://localhost:8000/'
// export const DEALER_IMAGE_BASE_URL = 'http://localhost:8000/'
// export const LOAN_PRODUCT_IMAGE_BASE_URL = 'http://localhost:8000/public/uploads/loanproduct'

export const SORT_KEY_RECENT = 'created_at'
export const SORT_KEY_NAME = 'name'

export const SORT_ORDER_ASC = 'asc'
export const SORT_ORDER_DESC = 'desc'

export const AGENT_RULE_ALL = 'abfd2554-c7b0-435f-94af-94b31492a2a6'

const CheckPermissions = (array, keyword, getState) => {
    if (getState) {
        return array?.filter((it) => it?.name === keyword).pop();
    } else {
        return array
            ?.filter((item) => item.name === `${keyword}`)
            ?.map((it) => it.view_permission == 1)
            ?.pop();
    }
};

export const HasPermission = (pathname, Permissions, getState) => {
    switch (pathname) {
        case "/loans/loan-products":
            return CheckPermissions(Permissions, "loan-product", getState);
        case "/loans/loan-providers":
            return CheckPermissions(Permissions, "loan-provider", getState);
        case "/accounts/agents":
            return CheckPermissions(Permissions, "agent-accounts", getState);
        case "/accounts/dealers":
            return CheckPermissions(Permissions, "dealer-accounts", getState);
        case "/user-roles":
            return CheckPermissions(Permissions, "user-roles", getState);
        case "/user-accounts":
            return CheckPermissions(Permissions, "user-accounts", getState);
        case "/notifications/loan/changes":
            return CheckPermissions(Permissions, "loan-changes", getState);
        case "/flooring/changes":
            return CheckPermissions(Permissions, "flooring-updates", getState);
        default:
            return null;
    }
};

export const clearLocalStorageExceptOne = (keysToRetain) => {
    const keys = Object.keys(localStorage);

    // Loop through the keys and remove items that are not in keysToRetain
    keys.forEach((key) => {
        if (!keysToRetain.includes(key)) {
            localStorage.removeItem(key);
        }
    });
};
export const ConvertByteToMb = (fileSize) => {
    const fileSizeBytes = fileSize; // bytes
    let fileSizeMB = Math.round(fileSizeBytes / 1024 ** 2);
    //console.log("fileSizeMB", fileSizeMB);
    return fileSizeMB;
};

export const PreApporval_Employment_Type = [
    {
        label: 'Employed-Private Sector',
        value: '1',
    },
    {
        label: 'Employed-Government Sector',
        value: '2',
    },
    {
        label: 'Self-employed',
        value: '3',
    },
    {
        label: 'Unemployed',
        value: '4',
    },
    {
        label: 'Retired',
        value: '5',
    },
]

export const CommomPermission = {
    create_permission: 1,
    delete_permission: 1,
    permission: 1,
    update_permission: 1,
    view_permission: 1
}

export const DuplicateCheck = (items) => {
    if (items !== undefined && items !== null && items?.length > 0) {
        const temp = items.filter(
            (ele, ind) => ind === items.findIndex((elem) => elem.id === ele.id)
        );
        return temp;
    } else {
        return items;
    }

}